/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_02_04_10_21
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EAlternativ } from './eAlternativ';
import { TPostPutPlannedCO2AmountList } from './tPostPutPlannedCO2AmountList';


export interface TPostFacilityAndPlannedCO2AmountDTO { 
    facility_name?: string | null;
    facility_city?: string | null;
    facility_latitude?: number;
    facility_longitude?: number;
    facility_street?: string | null;
    facility_street_number?: string | null;
    facility_zip_code?: string | null;
    facility_country_id?: number;
    facility_first_year_of_transport_capability?: number;
    facility_type_id?: number;
    facility_emission_type_id?: number;
    facility_customer_declaration_typ_id?: number;
    facility_customer_declaration?: string | null;
    facility_transport_target?: string | null;
    facility_alternative_selection?: EAlternativ;
    facility_alternative_text?: string | null;
    facility_description?: string | null;
    facility_data_sharing_with_authority_consent?: boolean;
    facility_data_sharing_with_third_part_consent?: boolean;
    facility_start_month_of_transport?: number | null;
    facility_willingness_to_pay_eur_per_ton?: number | null;
    facility_separation_technology?: string | null;
    facility_separation_and_cleaning_cost_eur_per_ton?: number | null;
    facility_maintenance_window_1?: string | null;
    facility_maintenance_window_2?: string | null;
    facility_maintenance_window_3?: string | null;
    facility_plan?: TPostPutPlannedCO2AmountList;
    facility_owner_email?: string | null;
}

